var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showNotice)?_c('div',{staticClass:"webNotice"},[_c('span',{staticStyle:{"float":"right","cursor":"pointer","margin-right":"10px"},on:{"click":_vm.closeBox}},[_vm._v("关闭×")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.webNotice.content)},on:{"click":_vm.closeBox}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }